import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=bd7fc85e"
import script from "./GeneralTab.ts?vue&type=script&lang=ts&external"
export * from "./GeneralTab.ts?vue&type=script&lang=ts&external"
import style0 from "./GeneralTab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports